import styled from 'styled-components';
import { AvGroup } from 'availity-mobx-reactstrap-validation';

export default styled(AvGroup)`
  grid-area: input;
  align-self: center;
  && {
    margin-bottom: 0;
  }
`;
